import React from 'react';
import propTypes from 'prop-types';
// import { Button } from 'semantic-ui-react';
import { message } from 'antd';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import { Button } from 'reactstrap';
// import { connect } from 'react-redux';

// import moment from 'moment';
import Notification from './../../../components/Alert';
import CreateContext from './../../store/CreateContext';
import { validateFrequency } from './utils';
import { Services } from '../../../../Services';
import { Col } from 'reactstrap';
import CardBody from 'reactstrap/lib/CardBody';

const Notify = ({ type, text }) => {
  if (type === 'success') {
    message.success(text);
  } else if (type === 'error') {
    message.error(text);
  } else if (type === 'warning') {
    message.warning(text);
  }
};

function SaveReport(props) {
  const context = React.useContext(CreateContext);
  const [updating, setUpdating] = React.useState(false);

  const { clients } = props;

  /*=============================================
  =            Scheme definition                =
  =============================================*/

  function createOndemandScheme(context, reportId = 0) {
    let scheme = {
      reportType: context.report_type,
      reportName: context.report_name.value,
      reportDescription: context.report_description.value,
      shareTo: context.share_to,
      module: context.module_selected,
      fields: context.selected_fields,
      filters: context.filters,
      order: context.order_fields,

      emailList: context.emailList,
      // customer: props.clients,
      customer: clients,
      user: localStorage.getItem('dataUser'),
      reportId: reportId
    };

    if (!reportId) delete scheme.reportId;

    return scheme;
  }
  function createScheduledScheme(context, reportId = 0) {
    let scheme = {
      reportType: context.report_type,
      reportName: context.report_name.value,
      reportDescription: context.report_description.value,
      shareTo: context.share_to,

      type: context.config.frequency,
      recurrence: context.config.frequency === 'Monthly' ? context.config.Monthly : context.config.Daily,
      startDate: context.config.startDate.value,
      endDate: context.config.endDate.value,
      hour: context.config.hour.value,
      day: Number(context.config.day),
      timeZone: context.config.timeZone,
      timeZoneValue: context.config.timeZoneValue,
      timeZoneStr: context.config.timeZoneStr,

      module: context.module_selected,
      filters: context.filters,
      order: context.order_fields,
      emailList: context.emailList,
      customer: props.clients,
      user: localStorage.getItem('dataUser'),
      fields: context.selected_fields,
      reportId: reportId
    };

    if (!reportId) delete scheme.reportId;

    return scheme;
  }

  /*=============================================
  =            Creation Functions               =
  =============================================*/

  const CreateOnDemand = React.useCallback(async (context) => {
    try {
      setUpdating(true);
      const body = createOndemandScheme(context);
      // const respCreate = 
      await axios.post(`${Services.REPORTS.path}report/builder/create/ondemand`, body);
      setUpdating(false);
      Notification(
        'Creado',
        'Report created successfully',
        'success'
      );
      context.model_reset();
      props.history.push('/Reports')
    } catch (error) {
      setUpdating(false);
      Notification(
        'Error',
        'Error creating report',
        'error'
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const CreateScheduled = React.useCallback(async (context) => {
    try {
      setUpdating(true);
      const body = createScheduledScheme(context);
      // const respScheduled =
      await axios.post(`${Services.REPORTS.path}report/builder/create/scheduled`, body);

      setUpdating(false);
      Notification(
        'Creado',
        'Report created successfully',
        'success'
      );
      context.model_reset();
      props.history.push('/Reports')
    } catch (error) {
      setUpdating(false);
      Notification(
        'Error',
        'Error creating report',
        'error'
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  /*=============================================
  =            Update Functions            =
  =============================================*/

  const UpdateOnDemand = React.useCallback(async (context, reportId, onEvent) => {
    try {
      setUpdating(true);
      const body = createOndemandScheme(context, reportId);
      // const resUpdate = 
      await axios.put(`${Services.REPORTS.path}report/builder/update/ondemand`, body);

      setUpdating(false);
      Notification(
        'updated report',
        'Report configuration Updated successfully',
        'success'
      );
      setTimeout(() => { onEvent(); }, 1200);
    } catch (error) {
      setUpdating(false);
      Notification(
        'Error',
        'Error trying to update report',
        'error'
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const UpdateScheduled = React.useCallback(async (context, reportId, onEvent) => {
    try {
      setUpdating(true);
      const body = createScheduledScheme(context, reportId);
      // const resUpdate = 
      await axios.put(`${Services.REPORTS.path}report/builder/update/scheduled`, body);
      setUpdating(false);
      Notification(
        'Updated report',
        'Report configuration Updated successfully',
        'success'
      );
      setTimeout(() => { onEvent(); }, 1200);
    } catch (error) {
      // console.error('UpdateScheduled -- ', error);
      setUpdating(false);
      Notification(
        'Error',
        'Error trying to update report',
        'error'
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);




  function handleSaveReport(type) {
    let valid = true;

    if (!context.report_name.value) {
      Notify({ type: 'error', text: 'the name of the report is required' });
      valid = false;
    } else if (!context.report_description.value) {
      Notify({ type: 'error', text: 'Description required' });
      valid = false;
    }


    if (context.report_type === 'ondemand') {
      if (!context.selected_fields.length) { Notify({ type: 'error', text: 'At least one selected field is required' }); valid = false; }
      if (valid) {
        if (type === 'create') {
          CreateOnDemand(context);
        } else {
          UpdateOnDemand(context, props.reportId, props.onEvent);
          // props.onEvent();
        }
      }
    } else if (context.report_type === 'scheduled') {
      if (context.config.frequency === 'Daily') {
        if (!validateFrequency(context.config.Daily)) { Notify({ type: 'error', text: 'No recurrence days have been selected' }); valid = false; }
        if (!context.config.hour.value) { Notify({ type: 'error', text: 'Select a valid time' }); valid = false; }
        if (!context.emailList.length) { Notify({ type: 'error', text: 'Provide one or more emails' }); valid = false; }
        if (!context.selected_fields.length) { Notify({ type: 'error', text: 'At least one selected field is required' }); valid = false; }

      } else if (context.config.frequency === 'Monthly') {
        if (!validateFrequency(context.config.Monthly)) { Notify({ type: 'error', text: 'Select recurrence months' }); valid = false; }
        if (!context.config.hour.value) { Notify({ type: 'error', text: 'Select a valid time' }); valid = false; }
        if (!context.emailList.length) { Notify({ type: 'error', text: 'Provide one or more emails' }); valid = false; }
        if (!context.config.day) { Notify({ type: 'error', text: 'Select a day of the month' }); valid = false; }
        if (!context.selected_fields.length) { Notify({ type: 'error', text: 'At least one selected field is required' }); valid = false; }
      } else {
        Notify({ type: 'error', text: 'Select frequency' });
        valid = false;
      }

      if (valid) {
        if (type === 'create') {
          CreateScheduled(context);
        } else {
          UpdateScheduled(context, props.reportId, props.onEvent);
          // props.onEvent();
        }
      }
    }
  };

  return (
    // <div className='col-md-6 d-flex justify-content-right col-md-6 col-sm-12 col-xs-12 col-lg-6 col-xl-6'>
    <Col sm='12' xs='12' lg='6' xl='6'>
      <CardBody>
        <div style={{ textAlignLast: 'right' }}>
          {/* {
            props.action === 'create' ?
              <Button.Group size='tiny'>
                <Button onClick={() => props.history.push('/Reports')}>Cancel</Button>
                <Button.Or text='' />
                <Button loading={updating} positive onClick={() => handleSaveReport('create')}>Save</Button>
              </Button.Group>
              :
              <React.Fragment>
                <Button loading={updating} positive size='tiny' onClick={() => handleSaveReport('edit')}>Save</Button>
              </React.Fragment>
          } */}
          {
            props.action === 'create' ?
              <>
                <Button onClick={() => props.history.push('/Reports')} color="danger" className='m-1'>Cancel</Button>
                <Button onClick={() => handleSaveReport('create')} color="primary" className='m-1'>Save</Button>
              </>
              :
              <Button positive size='tiny' onClick={() => handleSaveReport('edit')} color="primary">Save</Button>
          }
        </div>
      </CardBody>
    </Col >
    // </div>
  );
}

SaveReport.propTypes = {
  onEvent: propTypes.func
};
SaveReport.defaultProps = {
  onEvent: () => { }
};

// const mapStateToProps = state => ({
//   clients: state.header.clients
// });
// const mapDispatchToProps = () => ({
// });

// export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SaveReport));
export default (withRouter(SaveReport));
